angular.module('zc.projects')

.directive 'campaignNavigator', ($state, Campaign) ->
  restrict: 'E'
  scope:
    campaign: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_navigator.html'
  link: (scope, element, attrs) ->
    scope.$state = $state

    scope.nextState = (activeStep) ->
      switch $state.current.name
        when 'admin.projects.campaigns.edit.base'
          $state.go('admin.projects.campaigns.edit.template')
        when 'admin.projects.campaigns.edit.template'
          $state.go('admin.projects.campaigns.edit.incentive')
        when 'admin.projects.campaigns.edit.incentive'
          $state.go('admin.projects.campaigns.edit.policy')
        when 'admin.projects.campaigns.edit.policy'
          $state.go('admin.projects.campaigns.edit.schedule')
        when 'admin.projects.campaigns.edit.schedule'
          $state.go('admin.projects.campaigns.edit.confirm')

    scope.prevState = (activeStep) ->
      switch $state.current.name
        when 'admin.projects.campaigns.edit.template'
          $state.go('admin.projects.campaigns.edit.base')
        when 'admin.projects.campaigns.edit.policy'
          $state.go('admin.projects.campaigns.edit.incentive')
        when 'admin.projects.campaigns.edit.incentive'
          $state.go('admin.projects.campaigns.edit.template')
        when 'admin.projects.campaigns.edit.schedule'
          $state.go('admin.projects.campaigns.edit.policy')
        when 'admin.projects.campaigns.edit.confirm'
          $state.go('admin.projects.campaigns.edit.schedule')



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_navigator.coffee